import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import StaggeredMenu from '../components/StaggeredMenu/StaggeredMenu';

const menuItems = [
  { label: 'Inicio', ariaLabel: 'Ir a la página de inicio', link: '/' },
  { label: 'Servicios', ariaLabel: 'Ver nuestros servicios', link: '/services' },
  { label: 'Productos', ariaLabel: 'Ver nuestros productos', link: '/products' },
  { label: '¿Que es SUKO?', ariaLabel: 'Aprende sobre nosotros', link: '/aboutus' },
  { label: 'Contacto', ariaLabel: 'Contáctanos', link: '/contact' }
];

const socialItems = [
  { label: 'Twitter', link: 'https://twitter.com' },
  { label: 'GitHub', link: 'https://github.com' },
  { label: 'LinkedIn', link: 'https://linkedin.com' }
];

const Navigation = ({ onNavigate }) => {
  const handleLinkClick = (e) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute('href');
    onNavigate(href);
  };

  return (
    <>
      <div className="navigation-mobile" style={{position: 'absolute', height: '100vh'}}>
        <div style={{height: '100%', width: '100vw', overflow: 'hidden', position: 'relative'}}>
          <StaggeredMenu
            position="right"
            items={menuItems}
            socialItems={socialItems}
            displaySocials={false}
            displayItemNumbering={false}
            menuButtonColor="#1D4C4B"
            openMenuButtonColor="#0F1138"
            changeMenuColorOnOpen={true}
            colors={['#E7F58E', '#0F1138']}
            logoUrl={logo}
            accentColor="#7275BB"
            onMenuOpen={() => console.log('Menu opened')}
            onMenuClose={() => console.log('Menu closed')}
          />
        </div>
      </div>
      <nav className="navigation">
        <div className="nav-container">
          <div className="nav-logo">
            <Link to="/" onClick={(e) => handleLinkClick(e)}>
              <img className="nav-logo-img" src={logo} alt="SukoSpace" />
            </Link>
          </div>
          <div className="nav-links">
            <Link to="/services" onClick={(e) => handleLinkClick(e)}>SERVICIOS</Link>
            <Link to="/products" onClick={(e) => handleLinkClick(e)}>PRODUCTOS</Link>
            <Link to="/aboutus" onClick={(e) => handleLinkClick(e)}>SOBRE NOSOTROS</Link>
            <Link className="alter" to="/contact" onClick={(e) => handleLinkClick(e)}>CONTACTO</Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navigation;


